import { AiOutlineDelete, AiOutlineEdit } from 'react-icons/ai';
import { TbRestore } from 'react-icons/tb';
import { Link } from 'react-router-dom';
import { Card } from '../../../../../components/card/card';
import { IconButton } from '../../../../../components/icon-button/icon-button';
import { HasAccess } from '../../../../../features/has-access/has-access';
import { Table } from '../../../../../features/table/table';
import { TableFilterInput } from '../../../../../features/table/table-filter/table-filter-input/table-filter-input';
import { buildParams, concatPath } from '../../../../../helpers/path';
import { useLang } from '../../../../../hooks/use-lang';
import { useQueryParams } from '../../../../../hooks/use-query-params';
import { FormPath, ManagerPath, RootPath } from '../../../../../routes/manager/manager-enums';
import { useFormStore } from '../../../../../store/use-form-store';
import s from './forms-table.module.css';

export const FormsTable = () => {
  const { list } = useFormStore();

  const { t, getLocale } = useLang();
  const { addQueryParams } = useQueryParams();

  return (
    <Card>
      <Table
        id="form-list"
        columnSettings
        frontPagination
        className={s.table}
        onEmpty={{
          title: t('Список форм пуст'),
          text: t('Создайте первую форму с помощью кнопки выше'),
        }}
        cols={{
          name: {
            label: t('Название'),
            filter: (
              <TableFilterInput
                name="name"
                suggestOptions={list?.map((item) => getLocale(item.name))}
              />
            ),
          },

          actions: { label: t('Действия') },
        }}
        rows={list?.map((item) => ({
          name: getLocale(item.name),
          actions: (
            <HasAccess service="form" permissions={['write']}>
              {item.is_deleted ? (
                <IconButton
                  tooltip={t('Восстановить')}
                  variant="secondary"
                  size="sm"
                  onClick={() =>
                    addQueryParams({
                      restoreId: String(item.uuid),
                      restoreName: getLocale(item.name),
                    })
                  }
                >
                  <TbRestore />
                </IconButton>
              ) : (
                <div className={s.actions}>
                  <Link
                    to={
                      concatPath([RootPath.Manager, ManagerPath.Form, FormPath.Create]) +
                      buildParams({ id: item.uuid })
                    }
                  >
                    <IconButton tooltip={t('Редактировать')} size="sm" variant="secondary">
                      <AiOutlineEdit />
                    </IconButton>
                  </Link>

                  <IconButton
                    tooltip={t('Удалить')}
                    size="sm"
                    variant="secondary"
                    onClick={() =>
                      addQueryParams({
                        deleteId: item.uuid.toString(),
                        deleteName: getLocale(item.name),
                      })
                    }
                  >
                    <AiOutlineDelete />
                  </IconButton>
                </div>
              )}
            </HasAccess>
          ),
        }))}
      />
    </Card>
  );
};
